import { useSearchParams } from 'react-router-dom'
import { useMemo } from 'react'
import { log } from '@utils/debug'
import { useAppContext } from './use-app-context'

type URLParams = Partial<{
	CodiceAffinity: string
	Broker: string
	ProductType: string
	Product: string
	FinancialTable: string
	Amount: string
	InstallmentsNumber: string
	InstallmentAmount: string
	Token: string
	IdentinetActive: boolean
	Insurance: boolean
	identinetContractDuration: string
}>

export function useUrlParams(): URLParams {
	const { state } = useAppContext()

	const [query] = useSearchParams()

	log('query-change', query, query.toString())

	const isComparatore = state.data?.Provenienza === 'COMPARATORE'

	return useMemo(() => {
		if (isComparatore) {
			return {
				CodiceAffinity: state.defaults.ident,
				Broker: state.defaults.broker,
				//ProductType: query.get('tpprod') ?? undefined,
				//Product: query.get('prodt') ?? undefined,
				FinancialTable: state.defaults.tabfin,
				Amount: state.defaults.iamount,
				//InstallmentsNumber: query.get('nrate') ?? undefined,
				Token: state.defaults.token,
			}
		} else {
			return {
				CodiceAffinity: query.get('ident') ?? undefined,
				Broker: query.get('broker') ?? undefined,
				ProductType: query.get('tpprod') ?? undefined,
				Product: query.get('prodt') ?? undefined,
				FinancialTable: query.get('tabfin') ?? undefined,
				Amount: query.get('iamount') ?? undefined,
				InstallmentsNumber: query.get('nrate') ?? undefined,
				Token: query.get('token') ?? undefined,
			}
		}
	}, []) //@todo verifica se inserire dipendenze
}
